import React from "react";
import autoBind from "react-autobind";
import {notyEmitter} from "../../lib/noty";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

const initialState = {
  open: false,
  message: "",
  options: {}
};

export default class ConfirmModal extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {...initialState};
    this.notyEmitter = notyEmitter;
    this.notyEmitter.on("confirm", ({message, options}) => {
      this.setState({message, options, open: true});
    });
  }

  handleOnOk() {
    if (this.state.options.onOk) {
      this.state.options.onOk();
    }
    this.setState({...initialState});
  }

  handleOnCancel() {
    if (this.state.options.onCancel) {
      this.state.options.onCancel();
    }
    this.setState({...initialState});
  }

  render() {
    const {alert} = this.state.options;
    return (
      <div>
        <Dialog open={this.state.open} style={{zIndex: 3000}} maxWidth="md">
          <DialogContent style={{width: "400px"}}>
            <DialogContentText>{this.state.message}</DialogContentText>
            {!alert ? (
              <DialogActions>
                <Button color="primary" onClick={this.handleOnCancel}>
                  Cancel
                </Button>
                <Button color="primary" onClick={this.handleOnOk}>
                  Confirm
                </Button>
              </DialogActions>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/index.jsx